export default function Heading({
  subtitle,
  title,
}: {
  subtitle?: string
  title: string
}) {
  return (
    <div className="space-y-5">
      <h1 className="font-headline text-center text-2xl font-bold text-balance text-[#222222]">
        {title}
      </h1>

      {subtitle && (
        <p className="text-center text-sm text-balance text-[#AFAFAF]">
          {subtitle}
        </p>
      )}
    </div>
  )
}
